export default __webpack_public_path__ + "static/skai-75608dc668ce52a2d5337ef883713ad9.png";